export const primaryColor = '#C3073F';
export const primaryDarkColor = '#1A1A1D';

export const successColor = '#caf0f8';
export const infoColor = '#caf0f8';
export const errorColor = '#F2AF29';
export const warningColor = '#F2AF29';
